import { IModalComponent } from "@gtmhub/core/routing";
import { IMarketplaceInsightboardTemplate } from "@gtmhub/insightboards";
import { IComponentOptions, IController } from "angular";
import { IModalService } from "angular-ui-bootstrap";

export type PreviewInsightboardTemplateBindings = {
  insightboardTemplate: IMarketplaceInsightboardTemplate;
  addInsightboardTemplate(): void;
};

/* eslint-disable @typescript-eslint/no-empty-interface */
export interface IPreviewInsightboardTemplateBindings extends IModalComponent<PreviewInsightboardTemplateBindings> {}
export interface PreviewInsightboardTemplateCtrl extends IPreviewInsightboardTemplateBindings {}

export class PreviewInsightboardTemplateCtrl implements IController {
  addInsightboardTemplate(): void {
    this.close();
    this.resolve.addInsightboardTemplate();
  }
}

export class PreviewInsightboardTemplateModal {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  open(insightboardTemplate: IMarketplaceInsightboardTemplate, addInsightboardTemplate: () => void): void {
    this.$uibModal.open({
      component: "preview-insightboard-template",
      resolve: {
        insightboardTemplate: () => insightboardTemplate,
        addInsightboardTemplate: () => addInsightboardTemplate,
      },
      backdrop: true,
      windowClass: "w-750px vertical-offset-45px without-padding no-transform",
      backdropClass: "dark-backdrop",
    });
  }
}

export const PreviewInsightboardTemplateComponent: IComponentOptions = {
  controller: PreviewInsightboardTemplateCtrl,
  templateUrl: require("./preview-insightboard-template.jade"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
